import React from "react";

export const QuestionnairePageListPanel = ({
	text,
	hasBorder,
	isCentered,
	hasBackground,
	classes,
}) => {
	const ulClasses = "list-disc px-3 mb-3";
	let cls = classes || "";

	if (hasBorder) {
		cls += " border border-gray-400 ";
	}

	if (hasBackground) {
		cls += " bg-gray-100";
	}

	cls += isCentered ? " text-center" : " text-left";

	return (
		<div className={`mt-4 sm:mt-4 p-4 sm:p-4 ${cls} rounded-lg`}>
			<ul className={ulClasses}>
				{text.map((string, i) => (
					<li
						key={`${i}_text`}
						className={"pb-2 last:pb-0"}
						dangerouslySetInnerHTML={{ __html: string }}
					></li>
				))}
			</ul>
		</div>
	);
};
